import { supabase } from './supabase';

/**
 * NPS / satisfaction côté CLIENT (parité C4 — legacy `feedback.html`).
 * Le client note de 0 à 10 + commentaire → table `nps_responses` (lue par l'admin
 * NpsSection). La catégorie (promoter/passive/detractor) est dérivée du score.
 * Soumission via RPC `submit_nps_response` (SQL_P4). Helpers purs testables.
 */

export type NpsCategory = 'promoter' | 'passive' | 'detractor';

/** Catégorie NPS standard à partir d'un score 0-10. Pur. */
export function npsCategory(score: number): NpsCategory {
  if (score >= 9) return 'promoter';
  if (score >= 7) return 'passive';
  return 'detractor';
}

/** Valide un score NPS (entier 0-10). Pur. */
export function isValidScore(score: number): boolean {
  return Number.isInteger(score) && score >= 0 && score <= 10;
}

export interface NpsSubmission {
  tenantId: string;
  score: number;
  comment?: string;
  email?: string;
  name?: string;
}

/** Envoie une réponse NPS. Renvoie true si OK. */
export async function submitNps(sub: NpsSubmission): Promise<boolean> {
  if (!isValidScore(sub.score)) return false;
  const { data, error } = await supabase.rpc('submit_nps_response', {
    p_tenant_id: sub.tenantId,
    p_score: sub.score,
    p_comment: (sub.comment ?? '').trim().slice(0, 500) || null,
    p_email: (sub.email ?? '').trim().toLowerCase() || null,
    p_name: (sub.name ?? '').trim() || null,
  });
  if (error) {
    console.warn('[nps] submit_nps_response échoué:', error.message);
    return false;
  }
  return (data as { ok?: boolean } | null)?.ok !== false;
}
